import { render, staticRenderFns } from "./authorization.vue?vue&type=template&id=2d1bca43&scoped=true&"
import script from "./authorization.vue?vue&type=script&lang=js&"
export * from "./authorization.vue?vue&type=script&lang=js&"
import style0 from "./authorization.vue?vue&type=style&index=0&id=2d1bca43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bca43",
  null
  
)

export default component.exports